import AXIOS from '@/axios-instance';

export default {

  saveElementDescription(uuid, elementId, text) {
    return AXIOS.post("/elementDescription", {
      text: text,
      uuidModel: uuid,
      elementId: elementId,
    });
  },
  retrieveDescription(uuidModel, elementId) {
    return AXIOS.get("/elementDescription/bpmn/"+uuidModel+"/element/"+elementId);
  },
  editDescription(description) {
    return AXIOS.put("/elementDescription", description);
  },
  retrieveElementsWithDescription(uuid){
    return AXIOS.get("/elementDescription/bpmn/" + uuid);
  }
}